@for (card of cards(); track card.id) {
    <button
        qpxButton="unstyled"
        class="outcome-card"
        [class.shadow-xs]="appearance() === 'elevated'"
        [class.outlined]="appearance() === 'outlined'"
        [class.selected]="selected() === card.id"
        [style.--outcome-background]="`var(${card.colors.surface.variable})`"
        [style.--outcome-color]="`var(${card.colors.decorative.variable})`"
        [attr.aria-pressed]="selected() === card.id"
        [attr.aria-labelledby]="`${headingId()}-outcome-${card.id}`"
        [disabled]="disabled()"
        (click)="outcomeSelected.emit(card.id)"
    >
        <qpx-hero-icon
            [name]="card.icon"
            [context]="card.context"
            tone="muted"
            size="md"
            [active]="selected() === card.id"
            class="shrink-0"
            aria-hidden="true"
        />
        <span class="flex min-w-0 flex-col">
            <span
                qpxBody
                size="lg"
                class="font-semibold"
                [id]="`${headingId()}-outcome-${card.id}`"
                >{{ card.title }}</span
            >
            <span qpxBody="secondary" size="md">{{ card.description }}</span>
        </span>
    </button>
}
